import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ZipCodeInformation } from '../models/zorbek-sepomex/zip-code-information';
import { ServicesHelper } from '../helpers/index';

@Injectable()
export class ZorbekSepomexService {
  constructor(private httpClient: HttpClient, @Inject('ZORBEK_SEPOMEX_URL') private apiUrl) {}

  getZipCodeInformation(zipCode: string): Observable<ZipCodeInformation> {
    let url: string = this.apiUrl + 'zip-code/information/' + zipCode;    
    return this.httpClient.get<ZipCodeInformation>(url, {
      responseType: 'json',
      headers: ServicesHelper.getHeaders()
    });
  }
}
